import { Slot } from "@radix-ui/react-slot"
import { twMerge } from "tailwind-merge"

interface CardProps extends React.ButtonHTMLAttributes<HTMLDivElement> {
  asChild?: boolean
}

export const Card = ({className, children, asChild, ...props}: CardProps) => {
	const Comp = asChild ? Slot : "div"
  return (
    <Comp className={twMerge("bg-button-background border border-button-border rounded-[4px]", className)} {...props}>
      {children}
    </Comp>
  )
}